import DatetimeEditor from "./datetimeEditor";
import Fn_createBreakAttribute from "./fn_createBreakAttribute";
import Fn_createBreakLinksAttribute from "./fn_createBreakLinksAttribute";
import Fn_createLinkAttribute from "./fn_createLinkAttribute";
import Hrakleio_addDiagToMapRenderer from "./hrakleio_addDiagToMapRenderer";
import Hrakleio_diagLink from "./hrakleio_diagLink";
import Hrakleio_fileLink from "./hrakleio_fileLink";
import ImageEditor from "./image";
import TextEditor from "./textEditor";

function Editors(value, type, edit, attributes) {
  switch (type) {
    case "date":
      return DatetimeEditor(value, edit, attributes);
      break;

    case "image":
      return ImageEditor(value, edit, attributes);
      break;

    case "fn_createPhotoAttribute":
      break;

    case "fn_createBreakLinksAttribute":
      return Fn_createBreakLinksAttribute(value, edit, attributes);
      break;

    case "fn_createLinkAttribute":
      return Fn_createLinkAttribute(value, edit, attributes);
      break;

    case "fn_createAddDiagramAttribute":
      break;

    case "rae_certificates_renderer":
      break;

    case "rae_certificates_renderer":
      break;

    case "hrakleio_addDiagToMapRenderer":
      return Hrakleio_addDiagToMapRenderer(value, edit, attributes);
      break;

    case "Hrakleio_fileLink":
      return Hrakleio_fileLink(value, edit, attributes);
      break;

    case "hrakleio_diagLink":
      return Hrakleio_diagLink(value, edit, attributes);
      break;

    case "fn_createBreakAttribute":
      return Fn_createBreakAttribute(value, edit, attributes);
      break;

    default: {
      return TextEditor(value, edit, attributes);
    }
  }
}

export default Editors;
